import { render } from "./SurgeryCreate.vue?vue&type=template&id=553866be&scoped=true"
import script from "./SurgeryCreate.vue?vue&type=script&lang=js"
export * from "./SurgeryCreate.vue?vue&type=script&lang=js"

import "./SurgeryCreate.vue?vue&type=style&index=0&id=553866be&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553866be"]])

export default __exports__